import { api } from '../../api/Axios';

const getFavoritedProduct = (qs) => {
  const resource = `api/products/favorites?${qs}`;
  return api.get(resource);
};

const faveProduct = (productId, favorite) => {
  const resource = `api/products/${productId}/favorite/${favorite}`;
  const data = { };
  return api.post(resource, data);
};

const fetchProducts = (previous) => {
  const resource = 'Catalog/PreviousViewedProduct/Get';
  return api.post(resource, previous);
};
export default { getFavoritedProduct, faveProduct, fetchProducts };
